<template>
  <!--
    PoolaEndedView — a finished Poola, read-only: the finale card, then the
    viewer's run with phase="ended". Two hosts render it:
      • PoolaPage, when the CURRENT run is ENDED;
      • PoolaLastRunPage, for the last finished run while the next one counts down.
    Moved here unchanged from PoolaPage's three ENDED branches, so both pages show
    exactly the same screen.

    A CONTENT FRAGMENT with two root nodes — never its own <f7-page> (the host owns
    the page shell; nesting a page here would clip the fragment, playbook Section 5
    row 17). It owns no data: the host passes the run and its meta.festival.

    Viewer branch (meta.viewerRole): 'supplier' → read-only PoolaSupplierRun,
    'prospect' → read-only PoolaProspectRun (+ the join bar), anything else → the
    seller PoolaRun. Each keeps its own :key.
  -->
  <poola-pool-hero mode="ended" :festival="festival"></poola-pool-hero>

  <poola-supplier-run
    v-if="viewerRole === 'supplier'"
    key="srun-ended"
    phase="ended"
    :deal="deal"
    :server-offset="serverOffset"
    @deal-not-active="emit('deal-not-active')"
  ></poola-supplier-run>

  <poola-prospect-run
    v-else-if="viewerRole === 'prospect'"
    key="prun-ended"
    phase="ended"
    :deal="deal"
    :server-offset="serverOffset"
  ></poola-prospect-run>

  <poola-run
    v-else
    key="run-ended"
    phase="ended"
    :deal="deal"
    :server-offset="serverOffset"
    @deal-not-active="emit('deal-not-active')"
  ></poola-run>
</template>

<script setup>
import PoolaPoolHero from './PoolaPoolHero.vue';
import PoolaProspectRun from './PoolaProspectRun.vue';
import PoolaRun from './PoolaRun.vue';
import PoolaSupplierRun from './PoolaSupplierRun.vue';

defineProps({
  // The finished run: a poola-deals resource, or usePoolaDeal.previousRun (the
  // run components read only its id in the ended phase).
  deal: {
    type: Object,
    default: null,
  },
  // That run's meta.festival, for the finale card's two numbers.
  festival: {
    type: Object,
    default: null,
  },
  // serverNow − clientNow (ms) from usePoolaDeal, passed through to the run.
  serverOffset: {
    type: Number,
    default: 0,
  },
  // meta.viewerRole: 'seller' | 'supplier' | 'prospect' | null (→ the seller run).
  viewerRole: {
    type: String,
    default: null,
  },
});

// Bubbles to the host, which owns usePoolaDeal and refetches the singleton.
const emit = defineEmits(['deal-not-active']);
</script>
